import commonStyles from "utility/ui/common";

const styles = {
  accordion: commonStyles.accordion,
};

export default styles;
